import React, { useEffect, useState } from 'react';

import logger from 'helpers/logger';
import { getUrlForBlob } from 'helpers/pdfHelper';
import DownloadManager from 'api/DownloadManager/DownloadManager';
import { GeneralDialog, LoadingIndicator } from '..';
import { translate } from 'helpers/translateHelper';

/**
 *  Higher order component
 *  Converts an incoming blob pdf prop into a temporary url
 * 	Wrapped component gets it as a pdfContent prop,
 */
const withBlobContentPath = (WrappedComponent) => {
    const ModalWithBlob = (props) => {

        const { broadcastedMessagePath } = props;
        const [pdfUrl, setPdfUrl] = useState(null);
        const [loadedMessage, setLoadedMessage] = useState(null);

        const getLocalBlobUrl = () => {
            if (!broadcastedMessagePath) {
                setLoadedMessage(false);
                return;
            }
            DownloadManager.downloadBlob(broadcastedMessagePath, 'application/pdf')
                .then((messageBlob) => {
                    if (messageBlob && messageBlob.size > 0) {
                        setPdfUrl(getUrlForBlob(messageBlob));
                    } else {
                        // fall back to direct URL so PDFObject can embed it
                        setPdfUrl(broadcastedMessagePath);
                    }
                    setLoadedMessage(true);
                })
                .catch((err) => {
                    if (err && err.message) {
                        logger.error(`PDF download error: ${err.message}`);
                    }
                    // fall back to direct URL
                    setPdfUrl(broadcastedMessagePath);
                    setLoadedMessage(true);
                });
        };

        useEffect(() => {
            setPdfUrl(null);
            setLoadedMessage(null);
            getLocalBlobUrl();
        }, [broadcastedMessagePath]);

        // Revoke previous blob URL when pdfUrl changes or component unmounts
        useEffect(() => {
            return () => { window.URL.revokeObjectURL(pdfUrl); };
        }, [pdfUrl]);

        if (!broadcastedMessagePath) {
            return null;
        }

        const closeFunction = props.closable === false ? null : props.closeModal;

        return (
            pdfUrl ?
                <WrappedComponent {...props} pdfContent={pdfUrl} />
                :
                <GeneralDialog
                    {...props}
                    modalClassName='dropdown-modals modal-pdf'
                    close={closeFunction}>
                    <br />
                    {loadedMessage === false && broadcastedMessagePath
                        ? <b>{translate('ABB.Powertrain.Frontend.broadcastNoNotificationLabel')}</b>
                        : <LoadingIndicator size='medium' />}
                </GeneralDialog>
        );
    };

    return ModalWithBlob;
};

export default withBlobContentPath;
